export const EXCMAGREEMENTSLA_CREATE_RESET = 'EXCMAGREEMENTSLA_CREATE_RESET'
export const EXCMAGREEMENTSLA_CREATE_SET_CREATED = 'EXCMAGREEMENTSLA_CREATE_SET_CREATED'
export const EXCMAGREEMENTSLA_CREATE_SET_ERROR = 'EXCMAGREEMENTSLA_CREATE_SET_ERROR'
export const EXCMAGREEMENTSLA_CREATE_SET_VIOLATIONS = 'EXCMAGREEMENTSLA_CREATE_SET_VIOLATIONS'
export const EXCMAGREEMENTSLA_CREATE_TOGGLE_LOADING = 'EXCMAGREEMENTSLA_CREATE_TOGGLE_LOADING'
